import {Component, CSSProperties, PureComponent} from 'react'
import throttle from 'lodash/throttle'
import * as saturation from '../../helpers/saturation'
let React = require('react');

export class Saturation extends (PureComponent || Component) {
  throttle:any;
  props:any;
  container:any;
  constructor(props) {
    super(props)

    this.throttle = throttle((fn, data, e) => {
      fn(data, e)
    }, 50)
  }

  componentWillUnmount() {
    this.throttle.cancel()
    this.unbindEventListeners()
  }

  handleChange = (e) => {
    typeof this.props.onChange === 'function' && this.throttle(
        this.props.onChange,
        saturation.calculateChange(e, this.props.hsl, this.container),
        e,
    )
  }

  handleMouseDown = (e) => {
    this.handleChange(e)
    window.addEventListener('mousemove', this.handleChange)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseUp = () => {
    this.unbindEventListeners()
  }

  unbindEventListeners() {
    window.removeEventListener('mousemove', this.handleChange)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  render() {
    const { color, white, black, pointer, circle } = this.props.style || {}
    const styles = {
      color: {
        position: 'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        background: `hsl(${ this.props.hsl.h },100%, 50%)`,
        borderRadius: this.props.radius,
      },
      white: {
        position:'absolute',
        top:0,
        right:0,
        left:0,
        bottom:0,
        borderRadius: this.props.radius,
      },
      black: {
        position: 'absolute',
        top:0,
        left:0,
        bottom:0,
        right:0,
        boxShadow: this.props.shadow,
        borderRadius: this.props.radius,
      },
      pointer: {
        position: 'absolute',
        top: `${ -(this.props.hsv.v * 100) + 100 }%`,
        left: `${ this.props.hsv.s * 100 }%`,
        cursor: 'default',
      },
      circle: {
        width: '4px',
        height: '4px',
        boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
        borderRadius: '50%',
        cursor: 'hand',
        transform: 'translate(-2px, -2px)',
      },
    };

    return (
        <div
            style={ styles.color as CSSProperties}
            ref={ container => this.container = container }
            onMouseDown={ this.handleMouseDown }
            onTouchMove={ this.handleChange }
            onTouchStart={ this.handleChange }
        >
          <style>{`
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `}</style>
          <div style={ styles.white as CSSProperties} className="saturation-white">
            <div style={ styles.black as CSSProperties } className="saturation-black" />
            <div style={ styles.pointer as CSSProperties}>
              { this.props.pointer ? (
                  <this.props.pointer { ...this.props } />
              ) : (
                  <div style={ styles.circle } />
              ) }
            </div>
          </div>
        </div>
    )
  }
}

export default Saturation
